// ============================================================================
// OBT F2-B — Formen cevap akışı ekranı (orkestratör)
// ============================================================================
// Yerel görünüm state'i (yeni global router KURULMAZ; mevcut sekme/panel
// mimarisi korunur). Akış: Görev Listesi → Publication Detayı → Park Cevabı,
// ayrıca Publication Detayı içinde Filtre Dışı Park Önerisi diyaloğu.
//
// Her park cevabı `key` ile izole edilir; parktan dönüşte (kaydedilmişse)
// publication yeniden yüklenir (sayaç/park durumu tazelenir).
// ============================================================================

import { useRef, useState } from 'react';
import ForemanTaskList from './ForemanTaskList';
import PublicationDetail from './PublicationDetail';
import ParkResponseForm from './ParkResponseForm';

export default function ForemanResponseScreen({ enabled = true }) {
  const [view, setView] = useState('list'); // 'list' | 'publication' | 'park'
  const [publication, setPublication] = useState(null);
  const [park, setPark] = useState(null);
  const [questions, setQuestions] = useState([]);
  // Park formuna geçen TAZE son-tarih bilgisi (PublicationDetail snapshot'ından).
  // `publication` state'i (görev listesinden) süre uzatılmışsa bayat kalabilir.
  const [dueInfo, setDueInfo] = useState(null);
  const [pubRefreshKey, setPubRefreshKey] = useState(0);
  const parkSavedRef = useRef(false);

  const openPublication = (pub) => {
    setPublication(pub);
    setView('publication');
  };

  const openPark = (selectedPark, snapshotQuestions, freshDueInfo) => {
    setPark(selectedPark);
    setQuestions(snapshotQuestions || []);
    setDueInfo(freshDueInfo || null);
    parkSavedRef.current = false;
    setView('park');
  };

  const backToList = () => {
    setView('list');
    setPublication(null);
  };

  const backToPublication = () => {
    // Park cevabında değişiklik olduysa publication'ı yeniden yükle.
    if (parkSavedRef.current) {
      setPubRefreshKey((k) => k + 1);
      parkSavedRef.current = false;
    }
    setView('publication');
    setPark(null);
  };

  if (view === 'park' && publication && park) {
    return (
      <ParkResponseForm
        key={park.response_id || park.publication_park_id || park.supplemental_park_id || park.park_id}
        publicationId={publication.publication_id}
        dueAt={dueInfo?.dueAt ?? publication.response_due_at}
        duePassed={dueInfo?.duePassed}
        park={park}
        questions={questions}
        onBack={backToPublication}
        onSaved={() => {
          parkSavedRef.current = true;
        }}
      />
    );
  }

  if (view === 'publication' && publication) {
    return (
      <PublicationDetail
        key={`${publication.publication_id}_${pubRefreshKey}`}
        publicationId={publication.publication_id}
        enabled={enabled}
        onOpenPark={openPark}
        onBack={backToList}
      />
    );
  }

  return <ForemanTaskList enabled={enabled} onOpen={openPublication} />;
}
